import { defineStore } from 'pinia'
import { useFeatureFlagsStore } from './featureFlags'
import { useUserStore } from './user'

const useCompany = defineStore('Company', {
  persist: true,
  state: (): State => {
    return {
      company: null,
    }
  },
  actions: {
    setCompany(company: CompanyInfo | null) {
      this.company = company
        ? {
            id: company.id,
            code: company.code,
            name: company.name,
            companyId: company.companyId,
            client: company.client,
          }
        : null

      // Re-evalúa feature flags con la nueva compañía activa.
      // El contexto de usuario (id, cliente, rol) se toma del userStore,
      // que es donde vive la identidad autenticada.
      const { user } = useUserStore()
      void useFeatureFlagsStore().identify({
        userId: user?.id,
        companyId: this.company?.id,
        clientId: user?.clientId,
        role: user?.roles?.name,
      })
    },
  },
  getters: {
    getCompany(): CompanyInfo | null {
      return this.company ? this.company : null
    },
  },
})

interface State {
  company: CompanyInfo | null
}

interface CompanyInfo {
  id: string
  companyId: string
  code?: string
  name: string
  client: {
    id: string
    code?: string
    name: string
  }
}

export default useCompany
